import React from "react";

const useCompanyBranchesControllers = () => {
  const [showDeactivateModal, setShowDeactivateModal] = React.useState(false);
  const [singleDetails, setSingleDetails] = React.useState({});
  const [filter, setFilter] = React.useState({
    search: "",
    status: "",
    planType: "",
    location: "",
    startDate: "",
    endDate: "",
  });

  const handleFilterChange = (key: keyof typeof filter, value: string) => {
    setFilter((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleDeactive = (param: string) => {
    setSingleDetails(param);
    setShowDeactivateModal(true);
    console.log(param);
  };

  const handleSuspend = (param: string) => {
    setSingleDetails(param);
    console.log(param);
  };

  return {
    // state
    filter,
    showDeactivateModal,
    singleDetails,

    // function
    setFilter,
    handleFilterChange,
    handleDeactive,
    setShowDeactivateModal,
    handleSuspend,
  };
};
export default useCompanyBranchesControllers;
